module.exports = __webpack_public_path__ + "img/DFX.94af1c6c.jpg";